
import { useSelector } from "react-redux"
import { getMerchandisePartyTableList } from "@EUForms/utils"

const useValidatePartiesAtShipment = () => {
    const merchandiseMap = useSelector(state => state.invoiceReducer.invoice?.merchandiseMap) || {}
    const consigneeList = getMerchandisePartyTableList(merchandiseMap, 'consigneeList')
    const consignorsList = getMerchandisePartyTableList(merchandiseMap, 'consignorsList')
    const maxAllowedConsigneeList = consigneeList?.length > 0 ? 0 : 1
    const maxAllowedConsignorsList = consignorsList?.length > 0 ? 0 : 1
    return { maxAllowedConsigneeList, maxAllowedConsignorsList }
}

export default useValidatePartiesAtShipment